import { useEffect, useState } from "react";
import { useAppSelector } from "../store/reducers/store";
import { FundItem } from "../models/Fund";
import { Utilities } from "../utility/utils";

const useComplianceProportion = (): number =>{
    const allFunds = useAppSelector(state => state.libraryOfFundsReducer.allFunds);
    const active = useAppSelector(state => state.createPortfolio.portfolio.retailInvestors);
    const portfolioFunds = useAppSelector(state => state.createPortfolio.portfolio.funds);
    const fundraisingTarget = useAppSelector(state => state.createPortfolio.portfolio.fundraisingTarget);
    const [fullableProportion, setFullableProportion] = useState(0);

    useEffect(() => {
        if (active && allFunds !== undefined){
            const selectedFunds: FundItem[] = [];
            for(const f of portfolioFunds){
                selectedFunds.push(allFunds.find(fu => fu.id === f.id) as FundItem)
            }
            setFullableProportion(Utilities.getFullfillProportion(fundraisingTarget, selectedFunds));
        }
    },[allFunds, portfolioFunds]);

    return fullableProportion;
}

export default useComplianceProportion;